import { bscTestnet, matchain } from '@reown/appkit/networks';
import { Chain } from 'viem';

import { IS_DEV } from 'modules/common/const';

const bscTestnetChain: Chain = {
  ...bscTestnet,
  rpcUrls: {
    default: {
      http: [
        'https://rpc.ankr.com/bsc_testnet_chapel/2e787f5fcc014d39b69b9843da07a51502715b052854db1e0da103f3ea58bf75',
        ...bscTestnet.rpcUrls.default.http,
      ],
    },
  },
};

export function getChain(): Chain {
  if (IS_DEV) {
    return bscTestnetChain;
  }

  return matchain;
}
